import { useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { describeSetupIntent } from '../../../helpers/stripeStatus';

type PaymentDataStatusProps = {
  clientSecret?: string;
};

const PaymentDataStatus = ({ clientSecret }: PaymentDataStatusProps) => {
  const stripe = useStripe();
  const history = useHistory();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const secret = clientSecret || '';
    if (!secret) return;

    const report = (outcome: { ok: boolean; message: string }) => {
      if (outcome.ok) {
        toast.success(outcome.message);
      } else {
        toast.error(outcome.message);
      }
      history.replace({ search: '' });
    };

    stripe
      .retrieveSetupIntent(secret)
      .then(({ setupIntent, error }: any) => {
        if (error) {
          report({ ok: false, message: error.message || describeSetupIntent(undefined).message });
          return;
        }
        report(describeSetupIntent(setupIntent?.status));
      })
      .catch(() => {
        report(describeSetupIntent(undefined));
      });
  }, [stripe, clientSecret]);

  return <></>;
};

export default PaymentDataStatus;
